import { useQuery } from 'react-query';
import { axios } from '@/lib/axios';
import { ExtractFnReturnType } from '@/lib/react-query';
import { EventResponse } from '../types';

type UseBusinessOptions = {
  token: string;
};

export const getPaymentDetails = ({ token }: UseBusinessOptions): Promise<EventResponse> => {
  return axios.get(`/payment/details/${token}`);
};

type QueryFnType = typeof getPaymentDetails;

export const useGetPaymentDetails = ({ token }: UseBusinessOptions) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    queryKey: ['paymentDetails'],
    queryFn: () => getPaymentDetails({ token }),
  });
};

